var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminAudience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.81006C12.4069 9.81006 13.75 8.46691 13.75 6.81006C13.75 5.1532 12.4069 3.81006 10.75 3.81006C9.09315 3.81006 7.75 5.1532 7.75 6.81006C7.75 8.46691 9.09315 9.81006 10.75 9.81006Z",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 20.1899C3.25 18.2008 4.04018 16.2932 5.4467 14.8866C6.85322 13.4801 8.76088 12.6899 10.75 12.6899C12.7391 12.6899 14.6468 13.4801 16.0533 14.8866C17.4598 16.2932 18.25 18.2008 18.25 20.1899",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7202 12.5C18.6432 13.0898 19.4021 13.9032 19.9266 14.8647C20.4511 15.8263 20.724 16.9047 20.7202 18",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6499 4.31006C16.3129 4.31006 16.9488 4.57345 17.4177 5.04229C17.8865 5.51113 18.1499 6.14702 18.1499 6.81006C18.1499 7.4731 17.8865 8.10899 17.4177 8.57783C16.9488 9.04667 16.3129 9.31006 15.6499 9.31006",
    stroke: "#000D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAudience);
export default __webpack_public_path__ + "static/media/admin-audience.47109c2119b0a6fade3bb422626ff31c.svg";
export { ForwardRef as ReactComponent };